import { formatTime, toMinutes } from './appointmentDragUtils';

interface ResolveNewRecordEndTimeParams {
  /** Начало новой записи — начало свободной части шага сетки. */
  startTime: string;
  /** Конец свободной части шага: дальше идёт уже занятое время. */
  freeEndTime: string;
  /** Длительность секции из настроек журнала записей. */
  gridStepMinutes: number;
}

// Длительность новой записи по умолчанию равна длительности секции из
// настроек журнала записей (issue/11152), но не заходит на занятое время:
// у частично занятого шага запись заканчивается там, где начинается
// следующая (issue/11151).
export const resolveNewRecordEndTime = ({
  startTime,
  freeEndTime,
  gridStepMinutes,
}: ResolveNewRecordEndTimeParams): string => {
  const startMinutes = toMinutes(startTime);
  const freeEndMinutes = toMinutes(freeEndTime);
  const stepEndMinutes = startMinutes + gridStepMinutes;

  const endMinutes =
    freeEndMinutes > startMinutes
      ? Math.min(freeEndMinutes, stepEndMinutes)
      : stepEndMinutes;

  return formatTime(endMinutes);
};
